import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const defaultLogo =
    "https://customer-assets.emergentagent.com/job_bezalel-ux-update/artifacts/2jzt5ir3_LogoBitono.png";
  const scrolledLogo =
    process.env.REACT_APP_LOGO_SCROLLED ||
    "/assets/logo-blue.png";
  const [logoSrc, setLogoSrc] = useState(defaultLogo);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setLogoSrc(isScrolled ? scrolledLogo : defaultLogo);
  }, [isScrolled, scrolledLogo]);

  const navLinks = [
    { name: 'Inicio', href: '#hero' },
    { name: 'Nosotros', href: '#about' },
    { name: 'Servicios', href: '#services' },
    { name: 'Equipo', href: '#team' },
    { name: 'Contacto', href: '#contacto' }
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-lg shadow-lg' : 'bg-transparent'}`}
    >
      <nav className="container mx-auto px-4 py-3 md:py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img
              src={logoSrc}
              alt="Bezalel Technology"
              className="block h-10 sm:h-14 md:h-20 w-auto"
              onError={() => setLogoSrc(defaultLogo)}
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className={`text-sm font-medium transition-all duration-200 ${isScrolled ? 'text-gray-700 hover:underline underline-offset-4' : 'text-white hover:text-cyan-300 hover:underline underline-offset-4'}`}
              >
                {link.name}
              </a>
            ))}
            <Button
              onClick={(e) => scrollToSection(e, '#contacto')}
              className="bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 text-white"
            >
              Comenzar
            </Button>
          </div>

          {/* Mobile Menu Button — solid blue rounded square (matches mockup) */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-3 rounded-xl bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 text-white transition-colors duration-200 flex items-center justify-center"
            aria-label="Abrir menú"
          >
            {isMobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className={`md:hidden mt-4 py-4 rounded-lg shadow-xl border overflow-hidden transition-all duration-300 ${isScrolled ? 'bg-gradient-to-b from-white/70 to-white/30 backdrop-blur-2xl backdrop-saturate-150 border-white/40' : 'bg-gradient-to-b from-white/40 to-white/20 backdrop-blur-md border-white/30'}`}>
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className={`block px-4 py-3 transition-all duration-200 hover:underline underline-offset-4 ${isScrolled ? 'text-gray-800' : 'text-white'}`}
                style={isScrolled ? undefined : { textShadow: '0 3px 6px rgba(0,0,0,0.6)' }}
              >
                {link.name}
              </a>
            ))}
            <div className="px-4 py-3">
              <Button
                onClick={(e) => scrollToSection(e, '#contacto')}
                className="w-full bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 text-white"
              >
                Comenzar
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
